/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_New_ButtonInputs */

const en_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const fr_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const it_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const ru_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый`)
};

const es_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const zh_cn2_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新的`)
};

const ja_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい`)
};

const hi_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const pt_pt2_explorer_nav_new_button = /** @type {(inputs: Explorer_Nav_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Explorer_Nav_New_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_new_button = /** @type {((inputs?: Explorer_Nav_New_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_New_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_new_button(inputs)
	if (locale === "de") return de_explorer_nav_new_button(inputs)
	if (locale === "it") return it_explorer_nav_new_button(inputs)
	if (locale === "ru") return ru_explorer_nav_new_button(inputs)
	if (locale === "es") return es_explorer_nav_new_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_new_button(inputs)
	if (locale === "ja") return ja_explorer_nav_new_button(inputs)
	if (locale === "hi") return hi_explorer_nav_new_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_new_button(inputs)
	return en_explorer_nav_new_button(inputs)
});